export const KnockButtonAction = {
  Dismiss: 'dismiss',
  OpenGlobalInterfaceThemeSettings: 'open-global-interface-theme-settings',
} as const;
